import axios from '@configs/axios'

export const downloadDocAPI = async(file) => {
    const response = await axios({
        url: `/exports/download/${file}`,
        method: "GET",
    })
    
    return response?.data
}